var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "38px",
    viewBox: "0 0 32 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u89C6\u9891") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.358,0 L32,8.026 L32,35.45408 C32,36.8601528 30.8601528,38 29.45408,38 L2.54592,38 C1.13984721,38 1.72194254e-16,36.8601528 0,35.45408 L0,2.54592 C-1.72194254e-16,1.13984721 1.13984721,-1.07397625e-15 2.54592,0 L24.358,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u89C6\\u9891",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u89C6\\u9891_icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7B7FEB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#C7C9FE",
    mask: "url(#mask-2)",
    x: 24,
    y: -6.55172414,
    width: 12,
    height: 14.4137931,
    rx: 1.27296
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    transform: "translate(23.172414, 19.000000) rotate(-90.000000) translate(-23.172414, -19.000000) ",
    points: "20.5239398 16.2413793 25.7753965 16.2413793 28.6009852 21.7586207 17.7438424 21.7586207"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 5.51724138,
    y: 11.9428571,
    width: 15.4482759,
    height: 14.1142857,
    rx: 3.055104
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.125e1a1eee9f7b76bf0724d1abb64f98.svg";
export { ForwardRef as ReactComponent };